import TransactionsModule from './transactions.module'

export default TransactionsModule
